/**
 * «اپ رو بگیر» — هر دو فروشگاه، به‌علاوه‌ی یک QR وقتی روی گوشی نیستی.
 *
 * ═══ چرا یک کامپوننت و نه دو خط در هر صفحه ═══
 *
 * این همان چیزی‌ست که چند جا لازم می‌شود (پایینِ لینکِ عمومی، و صفحه‌ی بعد
 * از جواب) و همه باید یک شکل باشند.
 *
 * ═══ چرا هر دو دکمه، حتی وقتی می‌دانیم دستگاه چیست ═══
 *
 * یک بار این‌جا فقط فروشگاهِ «درست» نشان داده می‌شد و بقیه پنهان بود. تصمیمِ
 * بدی بود: تشخیصِ دستگاه از روی `userAgent` حدس است نه واقعیت — مرورگرها
 * دروغ می‌گویند، حالتِ دسکتاپِ مرورگرِ گوشی هست، و آدم گاهی صفحه را برای
 * کسِ دیگری با گوشیِ دیگری باز می‌کند. وقتی حدس غلط از آب دربیاید، تنها
 * راهِ درست **پنهان** شده و کاربر در بن‌بست است.
 *
 * پس هر دو همیشه هستند. حدس فقط یک کارِ کوچک‌تر می‌کند و آن هم برگشت‌پذیر
 * است: تعیینِ اینکه QR لازم است یا نه.
 *
 * ═══ QR استثناست، چون تنها چیزی‌ست که مستقیم می‌برد ═══
 *
 * QR روی گوشی بی‌معنی‌ست (با همان گوشی صفحه‌ی خودش را اسکن کند؟) ولی روی
 * دسکتاپ تنها راهِ واقعیِ نصب است: دو دکمه‌ی بالایش صفحه‌ی فروشگاه را روی
 * همان لپ‌تاپ باز می‌کنند که چیزی نصب نمی‌کند. QR به `/get` می‌رود و آن‌جا
 * تصمیم روی خودِ گوشیِ اسکن‌کننده گرفته می‌شود — نگاه کن به lib/appStore.ts.
 *
 * `navigator` فقط همین‌جا خوانده می‌شود و بلافاصله به `storeUrlFor` سپرده
 * می‌شود؛ خودِ قاعده هیچ‌وقت به مرورگر وابسته نیست، تا بشود تستش کرد.
 */
import React from 'react';
import { APP_STORE_URL, GET_APP_URL, PLAY_STORE_URL, storeUrlFor } from '@/core/lib/appStore';
import { t } from '@/core/lib/i18n';
import { AppQr } from './AppQr';
import { AppleIcon, GooglePlayIcon } from './icons';

export function StoreBadge() {
  // `navigator` روی سرور نیست؛ این اپ SPAی محضه ولی شرطش هزینه‌ای ندارد.
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const touch = typeof navigator === 'undefined' ? 0 : (navigator.maxTouchPoints ?? 0);
  // نبودنِ فروشگاهِ متناظر یعنی این دستگاه گوشی نیست — تنها چیزی که این حدس
  // این‌جا تعیین می‌کند، لازم بودنِ QR است.
  const onPhone = storeUrlFor(ua, touch) !== null;

  return (
    <div className="store-offer">
      <a className="play-badge" href={PLAY_STORE_URL} target="_blank" rel="noreferrer">
        <GooglePlayIcon size={20} />
        <span>{t('getItOnPlay')}</span>
      </a>
      <a className="play-badge" href={APP_STORE_URL} target="_blank" rel="noreferrer">
        <AppleIcon size={20} />
        <span>{t('getItOnAppStore')}</span>
      </a>

      {!onPhone ? (
        <div className="qr-offer">
          <AppQr />
          <p className="dim">{t('scanToInstall')}</p>
        </div>
      ) : null}
    </div>
  );
}

/** همان نشانی که داخلِ QR است — صفحه‌ی `/get` هم ازش استفاده می‌کند. */
export { GET_APP_URL };
